import {Text, TextStyleAlign, TextStyleFontWeight} from 'pixi.js';

export class TextFactory
{
    static DEFAULT_FONT = 'Jost';
    static DEFAULT_FONT_WEIGHT:TextStyleFontWeight = '500';

    /**
     * Создаём тектовое поле с указанными параметрами
     * @param text - текстовое содержимое
     * @param fontSize - размер шрифта
     * @param fill - заливка текста
     * @param align - выравниваниетекста по горизонтали
     * @returns Текстовое поле
     */
    public static create(text: string, fontSize: number = 16, fill: number = 0xffffff, align: TextStyleAlign = 'center'): Text {
        return new Text(text, {
            fontFamily: TextFactory.DEFAULT_FONT,
            //strokeThickness: 1,
            //stroke: fill,
            fontSize,
            fill,
            //textBaseline: 'middle',
            padding: Math.floor(fontSize / 5),
            align,
            fontWeight: TextFactory.DEFAULT_FONT_WEIGHT
        });
    }
}
